<template>
  <v-row>
    <v-col
      class="py-0"
      cols="12"
      sm="6"
      lg="3"
    >
      <material-stats-card
        color="primary"
        icon="mdi-account-multiple"
        title="Total Subordinates"
        :value="totalSubordinates"
      />
    </v-col>

    <v-col
      class="py-0"
      cols="12"
      sm="6"
      lg="3"
    >
      <material-stats-card
        color="secondary"
        icon="mdi-island"
        title="Annual Leave Applications"
        :value="totalAnnualLeave"
      />
    </v-col>

    <v-col
      class="py-0"
      cols="12"
      sm="6"
      lg="3"
    >
      <material-stats-card
        color="#FC2750"
        icon="mdi-hospital-box-outline"
        title="Sick Leave Applications"
        :value="totalSickLeave"
      />
    </v-col>

    <v-col
      class="py-0"
      cols="12"
      sm="6"
      lg="3"
    >
      <material-stats-card
        color="warning"
        icon="mdi-calendar-month"
        title="Other Leave Applications"
        :value="totalOtherLeave"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    components: {
      MaterialStatsCard: () => import('@/components/material/StatsCard'),
    },
    props: {
      totalSubordinates: {
        type: String,
        default: '',
      },
      totalAnnualLeave: {
        type: String,
        default: '',
      },
      totalSickLeave: {
        type: String,
        default: '',
      },
      totalOtherLeave: {
        type: String,
        default: '',
      },
    },
  }
</script>
